import { Component, OnInit, Input, OnDestroy} from '@angular/core';
import { ChartData, ChartingService } from 'src/app/_services/charting.service';
import { ExternalWorkoutService } from 'src/app/_services/generatedServices';


@Component({
  selector: 'external-speed-chart',
  templateUrl: 'speed-chart.component.html',
})
export class ExternalSpeedChartComponent implements OnInit, OnDestroy {
  initialized = false;
  hasData: boolean = true;

  @Input()
  clientProgramWorkoutDayId: number;

  @Input()
  isMetricSystem: boolean = false;


  constructor(private charting: ChartingService, private externalWorkoutService: ExternalWorkoutService) {}

  ngOnInit(): void {
    const title = 'Speed (' + (this.isMetricSystem ? 'kmph' : 'mph') + ')';
    const chartHeaders: any[] = [{ type: 'timeofday', id: 'Time', label: 'Time' }, { type: 'number', id: 'Speed', label: title }];

    this.externalWorkoutService.getSpeedChartData(this.clientProgramWorkoutDayId, this.isMetricSystem).subscribe(result => {
      this.hasData = result.length > 0;

      this.charting.queueCharts(
        this.charting.drawScatterChart.bind(this.charting),
        new ChartData(
            'speedChart',
            chartHeaders,
            result.map(x => [x.timerDuration, x.value]),
            title
        )
      );
      this.initialized = true;
    });
  }

  ngOnDestroy() {
    this.charting.unsubscribe();
  }
}
